module.exports = __webpack_public_path__ + "img/Practical Fixer.308a7cf5.svg";